import {
  AppContent,
  setAppContent
} from '@dtx-company/inter-app/src/redux/slices/app-content-slice'
import { EnhancedStore } from '@reduxjs/toolkit'
import { store } from '@dtx-company/inter-app/src/redux/store'
import { useState } from 'react'

export const useInitializeReduxStore = (appContent: AppContent): Readonly<[EnhancedStore]> => {
  return useState(() => {
    store.dispatch(setAppContent(appContent)) //load into serverside store state to avoid clientside flicker
    return [store] as const
  })[0]
}
